export class SignupOverviewList {
    public signupFormHashId: string = '';
    public signupFormConfigHashId: string = '';
    public startDateTime: string = '';
    public endDateTime: string = '';
    public signupDateTime: string = '';
    public instanceName: string = '';
    public userName: string = '';
    public email: string = '';
    public signupFormDescription: string = '';
    public status: string = '';
    public isEditable  : boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/signupform/models/signup-list.model.ts